import { Template, Component, Attribute } from '@scoutgg/ftw/source/lib'
import template from './logs.jade'
import { Log } from '../../models'
import '../status'
import moment from 'moment'
import '@scoutgg/ftw/source/atoms/loading/loading'
import pushState from '../../services/state'

@Component('sporty')
@Attribute('user', String)
@Attribute('end', String)
@Attribute('start', String)
@Template(template)
export default class Logs extends HTMLElement {
  created() {
    this.page = 0
    this.size = 50
    this.display = 4
    this.userInfo = null
    this.translations = {
      newLeague: 'added new league',
      editLeague: 'edited league',
      newSeason: 'added new season',
      editSeason: 'edited season ',
      newMatch: 'added new match',
      editMatch: 'edited match',
      mapMatch: 'mapped match',
      unmapMatch: 'unmapped match',
      newTeam: 'added new team ',
      editTeam: 'edited team',
      mapTeam: 'mapped team',
      unmapTeam: 'unmapped team',
      newPlayer: 'added new player',
      mapPlayer: 'mapped player',
      editPlayer: 'edited player',
      price: 'updated price',
      lineup: 'created lineup',
      lineupUpdated: 'updated lineup',
      startMatch: 'started match',
      cancelMatch: 'canceled match',
      confirmMatch: 'confirmed match',
      endMatch: 'ended match',
      pauseMatch: 'paused match',
      unpauseMatch: 'unpaused match',
      sendMatchFeeds: 'sent match feeds',
      oldPrice: 'old price',
      factor: 'factor',
      oldFactor: 'old factor',
    }
    this.tabsTranslations = {
      all: 'All activities',
      price: 'Price page',
      players: 'Player source',
      matches: 'Match source',
      teams: 'Team source',
      lineup: 'Lineup',
    }
    this.tabs = ['all', 'price', 'players', 'matches', 'teams', 'lineup']
    if (!this.tab) {
      this.tab =
        (window.location.search.split('&').find(e => e.includes('tab')) || '')
          .split('=')
          .pop() || this.tabs[0]
    }
  }

  async attached() {
    window.addEventListener('popstate', ev => {
      this.tab = (ev.state && ev.state.tab) || this.tab
      this.page = (ev.state && ev.state.page) || this.page
    })
    const {page, tab} = this
    pushState({ tab, page })
    this.start = moment()
      .subtract(1, 'days')
      .toISOString()
    await this.reload()
  }
  setPlayer({ target }) {
    let id = target.value
    this.user = id === 'all' ? null : id
    this.reload()

    this.render()
  }
  reload() {
    this.render((this.$isLoading = true))
    let now = moment()
    let defaultTo = now.toISOString()
    let defaultFrom = now.subtract(1, 'days').toISOString()
    let to = this.end ? moment(this.end).toISOString() : defaultTo
    let from = this.start ? moment(this.start).toISOString() : defaultFrom
    let params = {
      $reload: true,
      fromTime: from,
      toTime: to,
      user: this.user,
      limit: this.size,
      page: this.page,
      group: this.tab,
    }
    return this.update(Log.load(params)).then(() => {
      this.$isLoading = false
      this.playerMap = (this.players || {}).reduce((obj, p) => {
        obj[p._id] = p
        return obj
      }, {})
      this.render()
    })
  }
  setTab(tab) {
    this.tab = tab
    pushState({ tab, page: 0 })
    this.reload()
  }
  abriviature(username) {
    return (username || '')
      .split(' ')
      .map(i => i.charAt(0))
      .join('')
  }
  toggleUserInfo(log) {
    this.userInfo === log._id
      ? (this.userInfo = null)
      : (this.userInfo = log._id)
    this.render()
  }

  endChange() {
    this.reload()
  }
  startChange() {
    this.reload()
  }
  changePage(e) {
    this.page = e
    const { page, tab } = this
    pushState({ page, tab })
    this.reload()
  }
  findPlayer(player) {
    let found = (this.players || []).find(p => p._id === player) || {}
    return found.fullName || player
  }
  findTeam(team) {
    let found = (this.teams || []).find(t => t._id === team) || {}
    return found.name || team
  }
  findMatch(match) {
    let found = (this.matches || []).find(m => m._id === match) || {}
    return found.descriptor || match
  }
  findSeason(season) {
    let found = (this.seasons || []).find(s => s._id === season) || {}
    return found.name || season
  }
  getProperValue(key, value) {
    if (['player', 'team', 'match'].includes(key)) {
      let method = key.charAt(0).toUpperCase() + key.slice(1)
      return this[`find${method}`](value)
    }
    return value
  }
  matchPriceChanges(entry) {
    const ret = []
    for(const attr of ['price', 'oldPrice', 'factor', 'oldFactor']) {
      if(entry[attr] == null) continue
      ret.push({
        attr: attr,
        label: this.translations[attr],
        value: entry[attr],
      })
    }
    return ret
  }
}
